import React from "react";
import { App, Page, Navbar, Block } from 'konsta/react';
import { Link, Route, Switch} from "wouter";
import  {useLocation as location2} from "wouter";
import Main from "./pages/main";
import Profile from "./pages/profile";
import Login from "./pages/login";
import Register from "./pages/register";
import EditAddress from "./pages/editAddress";
import Cart from "./pages/cart";
import Checkout from "./pages/checkout";
import TipoSelect from "./pages/tipoSelect";
import Order from "./pages/order";
import RegisterTicket from "./pages/registerTicket";
import PointHistory from "./pages/pointHistory";
import orderHistory from './pages/orderHistory';
import Success from "./pages/success";
import { useTransition,animated } from "@react-spring/web";
const cn = require('classnames');


function myApp(){
  return (
    <App safeAreas>
      {/*<Page>
        <Main/> 
      </Page>*/}
      <Route path="/" component={Main} />
      <Route path="/profile" component={Profile} />
      <Route path="/login" component={Login} />
      <Route path="/register" component={Register} />
      <Route path="/editAddress/:id" component={EditAddress} />
      <Route path="/cart" component={Cart} />
      <Route path="/tipoSelect" component={TipoSelect} />
      <Route path="/checkout" component={Checkout} />
      <Route path="/order" component={Order} />
      <Route path="/ticketReg" component={RegisterTicket} />
      <Route path="/pointHistory" component={PointHistory} />
      <Route path="/orderHistory" component={orderHistory} />
      <Route path="/success" component={Success} />
    </App>
  );
}

export default myApp;
